import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import Button from '../Button/Button'
import style from './CloseButton.style'

type CloseButtonProps = {
  className?: string
  variant: 'dark-on-light' | 'light-on-dark'
} & ComponentProps<'button'>

function CloseButton(props: CloseButtonProps): ReactElement {
  const { className = '', variant, ...rest } = props

  return (
    <Button
      className={cn('CloseButton', variant, className)}
      css={style}
      variant="no-shell"
      dropShadow={false}
      {...rest}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // the center from the <path>'s point of view is at (4.5, 4.5)
        // and the whole thing is 16x16
        viewBox="4.5 4.5 16 16"
        aria-label="Close"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="m12.5 12.5 4.243-4.243L12.5 12.5 8.257 8.257 12.5 12.5Zm0 0-4.243 4.243L12.5 12.5l4.243 4.243L12.5 12.5Z"
        />
      </svg>
    </Button>
  )
}

export default CloseButton
